var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNext = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.9998 2.5C13.9998 2.22386 13.7759 2 13.4998 2C13.2236 2 12.9998 2.22386 12.9998 2.5V13.5C12.9998 13.7761 13.2236 14 13.4998 14C13.7759 14 13.9998 13.7761 13.9998 13.5V2.5ZM2 3.00176C2 2.19 2.91615 1.71649 3.57836 2.18598L10.5788 7.14909C11.1385 7.54594 11.1414 8.37575 10.5845 8.77654L3.58411 13.8142C2.9226 14.2903 2 13.8176 2 13.0026V3.00176ZM10.0004 7.96486L3 3.00176L3 13.0026L10.0004 7.96486Z",
  fill: "#262626"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNext, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/next.7e236126.svg";
export { ForwardRef as ReactComponent };